import Button from '../../components/Button'
import Card from '../../components/Card'

const SUPPORT_CALL_URL = 'https://discord.com/channels/1187941664841535559/1187942865846927500'

export default function IntroductionStep({ onNext }) {
  return (
    <div className='flex flex-col w-full h-full items-center justify-center'>
      <Card withGradient className='relative overflow-hidden shadow-[0_30px_80px_rgba(0,0,0,0.45)]'>
        <div className='px-14 md:px-20 py-12 flex flex-col gap-8 text-white w-[540px] md:w-[760px] max-w-full'>
          <div className='text-3xl md:text-[36px] font-extrabold leading-tight drop-shadow-[0_8px_24px_rgba(13,217,156,0.35)]'>
            <div>Warte mal!</div>
            <div>
              Bevor du alles <span className='text-primary'>verlierst</span>...
            </div>
          </div>
          <div className='text-neutral-300 text-base md:text-lg leading-relaxed max-w-[620px]'>
            Wir sehen, dass du Zeit &amp; Arbeit in Edge investiert hast. Gib diesen Fortschritt nicht umsonst auf. Pausiere erstmal dein Abonnement und sprich mit uns, in 99% hilft ein kurzer Call mit dem Team um deine Probleme zu lösen und deinen Erfolg zu steigern.
          </div>
          <div className='flex flex-wrap gap-3 pt-3'>
            <Button
              className='px-16 py-3 rounded-[22px] bg-gradient-to-r from-emerald-300 via-emerald-400 to-emerald-500 text-black font-extrabold text-lg shadow-[0_18px_55px_rgba(16,185,129,0.45)]'
              href={SUPPORT_CALL_URL}
              target='_blank'
              rel='noopener noreferrer'
            >
              Ja pausieren
            </Button>
            <Button
              className='px-7 py-2 rounded-[22px] bg-black/40 text-neutral-600 text-xs font-medium border border-white/5 flex items-center justify-center'
              onClick={onNext}
            >
              Weiter zur Kündigung
            </Button>
          </div>
        </div>
      </Card>
    </div>
  )
}
